import { render, staticRenderFns } from "./LayoutFlexbox.vue?vue&type=template&id=fa6d8ffa&scoped=true"
import script from "./LayoutFlexbox.vue?vue&type=script&lang=js"
export * from "./LayoutFlexbox.vue?vue&type=script&lang=js"
import style0 from "./LayoutFlexbox.vue?vue&type=style&index=0&id=fa6d8ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6d8ffa",
  null
  
)

export default component.exports